module.exports = __webpack_public_path__ + "assets/14b9e2c5b473ba4c18c3e0009f1e5109.svg";